module.exports = __webpack_public_path__ + "img/2003 (5).45a4221e.jpg";